import { styled } from 'libs/ui/styled';

export const ContentStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 24,
  [theme.breakpoints.down('tablet')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16,
  },
}));
